<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="title"
    :max-width="500"
    color="primary"
    activator-simple-link
    custom-class="mr-2"
    @open="showTowPlanes"
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-list two-line style="overflow-y: scroll">
        <v-list-item-group
          v-model="selected"
          active-class="blue--text"
        >
          <template v-for="tow_plane in towPlanes">
            <v-list-item :key="tow_plane.id">
              <v-list-item-icon class="pa-1 ma-1">
                <v-img
                  v-if="tow_plane.avatar"
                  max-height="50px"
                  :src="'data:image/jpeg;base64,' + tow_plane.avatar.thumbnail"
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> {{ tow_plane.name }} </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  color="primary"
                  small
                  @click="clickPlaneSelect(tow_plane)"
                >
                  {{ $t('select') }}
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </template>
  </cumulus-info-dialog>
</template>

<script>
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'TowPlaneSelector',
    props: {
      preFlight: {
        type: Object,
        default: () => ({}),
      },
      title: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialogInfo: false,
        selected: [],
        current_date: null,
        towPlanes: [],
      }
    },
    computed: {
      profile: get('auth/profile'),
    },
    mounted () {
      this.fetchDatasource({ sourceType: 'tow-planes-avatar' }).then(response => {
        this.towPlanes = response
      })
    },
    methods: {
      fetchDatasource: call('datasource/fetchDatasource'),
      changeTowPlane: call('dailyFlight/changeTowPlane'),
      async showTowPlanes () {
      },
      async clickPlaneSelect (plane) {
        await this.changeTowPlane({ id: this.preFlight.id, tow_plane_id: plane.id }).then(response => {
          // this.$set(preFlight, 'pivot', { comment: '', success: 0 })
          // this.userTrainingTask.flights.push(flight)
          this.preFlight.tow_plane = response.tow_plane
          this.closeDialog()
        })
      },
      closeDialog () {
        this.flights = []
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
